import { compose } from 'redux';
import { connect } from 'react-redux';
import subscriptionDecorator from 'subscriptions/decorator';
import * as routes from 'app/routes';

import {
  getCurrentAttPlan,
  getUpcomingAttPlan,
  getAllAttPlans,
  getOverduePurchases,
  getUser,
} from 'reducers';

import {
  fetchAll as fetchAllPlans,
  findUpcoming as findUpcomingPlan
} from 'subscriptions/plans/att/actions';

import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/actions';

import { createAttUpgrade as createUpgradePurchase } from 'billing/purchases/actions';
import AddDataPicker from './AddDataPicker';


const mapStateToProps = (state, { subId }) => ({
  upcomingPlan: getUpcomingAttPlan(state, subId),
  currentPlan: getCurrentAttPlan(state, subId),
  allPlans: getAllAttPlans(state),
  overduePurchases: getOverduePurchases(state),
  user: getUser(state),
});

const mapDispatchToProps = {
  fetchAllPlans,
  findUpcomingPlan,
  createUpgradePurchase,
  purchaseRoute: routes.attAddDataPurchase,
  fetchFilteredPurchases,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddDataPicker);
